module.exports = __webpack_public_path__ + "static/media/counter.7b9bc94c.png";